export default {
  //
  // GENERAL
  //
  HTML_TITLE:
    "TestTheTest - Autonomous quality assurance for web, mobile and desktop apps",
};
